import { common } from './common'
import { auth } from './auth'
import { shell } from './shell'
import { home } from './home'
import { submissions } from './submissions'
import { tasks } from './tasks'
import { fiveS } from './fiveS'
import { profile } from './profile'
import { analytics } from './analytics'
import { admin } from './admin'
import { guide } from './guide'
import { owner } from './owner'

/**
 * Bosnian, assembled from one file per screen.
 *
 * It started as a single file and was split when the login slice alone reached
 * a hundred keys — not for tidiness, but because several people translate
 * different screens at once and one file is one merge conflict. A namespace per
 * screen means the person doing Analytics never opens the file the person doing
 * Admin is editing.
 *
 * The keys stay **globally flat and dotted** — `home.greeting`, not a nested
 * `home: { greeting }`. That is what keeps `keyof` a usable union, so `t()` is
 * checked at compile time and a typo is a build error rather than a dotted path
 * rendered on a button. The file a key lives in is an authoring convenience;
 * the key itself does not know about it.
 *
 * Nothing here holds an enum label. Statuses, types, priorities, roles and
 * months come from `/api/meta` — see `types/api.ts` for why the client
 * deliberately keeps no copy.
 */
export const bs = {
  ...common,
  ...auth,
  ...shell,
  ...home,
  ...submissions,
  ...tasks,
  ...fiveS,
  ...profile,
  ...analytics,
  ...admin,
  ...guide,
  ...owner,
} as const

/** Every key the application may ask for. */
export type TranslationKey = keyof typeof bs

export type Dictionary = Record<TranslationKey, string>
